import { type FC } from "react";
import { useTranslation } from "react-i18next";
import {
  useCheckboxGroup,
  Stack,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Flex,
} from "@chakra-ui/react";
import { useField } from "formik";
import { CheckboxCard } from "./CheckboxCard";
import { SupportingText } from "./SupportingText";

export interface Option {
  supportingText?: string;
  text: string;
  value: string;
}

interface Props {
  defaultValue?: string[];
  label?: string;
  id: string;
  options: Option[];
}

export const CheckboxInput: FC<Props> = ({
  defaultValue = [],
  id,
  label,
  options,
}) => {
  const { t } = useTranslation();
  const [field, meta] = useField(id);
  const { getCheckboxProps } = useCheckboxGroup({ defaultValue });

  return (
    <FormControl isInvalid={meta.touched && !!meta.error}>
      {label && <FormLabel htmlFor={id}>{label}</FormLabel>}

      <Flex direction="column" gap={2} w="full">
        <SupportingText textAlign="left">
          {t("onboarding.inputs.checkbox")}
        </SupportingText>

        <Stack {...field}>
          {options.map(({ supportingText, text, value }, index) => (
            <CheckboxCard
              key={value}
              name={id}
              index={index}
              supportingText={supportingText}
              text={text}
              {...getCheckboxProps({ value })}
            />
          ))}
        </Stack>
      </Flex>

      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};
